<div *ngIf="!comparisonService.isComparePage">
  <div class="innerpage-fullwithbanner clearfix" *ngIf="!callFromComponent">
    <div class="left">
      <h2 class="bighead">1031 Trade Portfolio</h2>
      <ul class="bread-crumbs">
        <li><a (click)="_ValidationService.redirect('/')">Home<span>|</span></a></li>
        <li>1031 Trade Portfolio</li>
      </ul>
    </div>
    <div class="right">
      <label class="select breadcumbarea-select bigselect">
        <app-1031-exchange-selector></app-1031-exchange-selector>
      </label>
    </div>
  </div>

  <div class="section-margin">
    <div class="container container-lg min-heightcontainer">
      <div class="border-div margin-bottom-0">

        <div class="tabstyle2 onlytopborder clearfix">
          <tabset>
            <tab heading="Pipeline" id="tab1">

              <!--Top Navigation Start Here-->
              <div class="text-right tradepipeline-topbar clearfix margin-bottom-10">
                <button *ngIf="showSuggestButton && noDataOnPageLoad" class="btn btn-sm bluelink"
                  (click)="viewSuggestProperties(PropertySuggest,'suggestproperty');">Suggest Properties</button>

              </div>


              <div *ngIf="!noDataOnPageLoad" class="tradepipeline-topbar clearfix margin-bottom-10">
                <div class="left">
                  <ul class="filter-section" style="text-align:left">
                    <li (click)="onViewChange(1)" [class.active]="view === Views.List">
                      <a>
                        <i class="icon-list icon"></i>
                      </a>
                    </li>
                    <li (click)="onViewChange(2)" [class.active]="view === Views.Grid">
                      <a>
                        <i class="icon-grid icon"></i>
                      </a>
                    </li>
                  </ul>
                  <button class="btn btn-sm blue-border-btn" *ngIf="portfolioList?.length > 0"
                    (click)="viewAnalytics(true)">Property Analysis</button>
                  <button class="btn btn-sm blue-border-btn" *ngIf="portfolioList?.length > 0"
                    (click)="viewAnalytics(false)">Portfolio Analysis</button>
                  <button *ngIf="showSuggestButton && !noDataOnPageLoad" class="btn btn-sm bluelink"
                    (click)="viewSuggestProperties(PropertySuggest,'suggestproperty');">Suggest Properties</button>

                </div>



                <div class="right">

                  <div class="search-sec" *ngIf="view === Views.List">
                    <input class="form-control" [(ngModel)]="searchString" (keyup)="onSearch();" type="text"
                      placeholder="Tenant, Price..">
                    <i class="fa fa-search icon" aria-hidden="true"></i>
                  </div>
                  <!--commented-->

                </div>
              </div>

              <div *ngIf="view === Views.List" class="bluebg-blocks margin-bottom-10">
                <ul class="clearfix clickable">
                  <li *ngFor="let item of portfolioTileList;let i=index">
                    <div class="whiteblock transition" [ngClass]="{'active':(item.isActive==true)}"
                      (click)="tileFilterClick(item.Title)">
                      <h2>{{item.Title =='Declined/Cancelled' ? 'Declined/Canceled' : item.Title}} <span
                          [style.background-color]="item.Color" class="transition"></span></h2>
                      <h4>{{item.Count|number}} Properties</h4>
                      <div class="clearfix"></div>
                      <h3>{{item.Price == null ? '-': '$'+ (item.Price |number) }}</h3>

                    </div>
                  </li>
                  <!--<li>
        <div class="whiteblock transition" [ngClass]="{'active':(isviewAll==true)}" (click)="tileFilterClick('View All');">
          <h4>{{portfolioListCount}} Properties</h4>
          <h5>View All</h5>
        </div>
      </li>-->
                </ul>

              </div>
              <div class="text-right  margin-bottom-20" *ngIf="view === Views.List">
                <a (click)="tileFilterClick('View All')" class="bluelinkunderline"
                  style="margin-bottom: 5px;text-decoration:underline !important;font-weight:600 !important;">View
                  All</a>
              </div>
              <div *ngIf="noDataOnPageLoad" class="tradepipeline-topbar clearfix margin-bottom-10">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Data Available</p>
                </div>

              </div>


              <!--Top Navigation End Here-->
              <!--List View Start here-->
              <div *ngIf="view === Views.List && !noDataOnPageLoad" class="table-fixed col-md-12 cf">

                <div class="table-responsive" style="max-height:700px;overflow-y:auto">

                  <table class="table basictable row-border hover pipeline-table">
                    <thead>
                      <tr>
                        <th style="width:35px"></th>
                        <th *ngIf="isviewAll || viewActions" class="sticky-left z-100">Actions</th>
                        <th>OM</th>
                        <th>LOI</th>
                        <th></th>
                        <th *ngIf="isviewAll">Pipeline</th>
                        <th class="min-width-td">Tenant</th>
                        <th *ngIf="showStarRating">Rating</th>
                        <th>Status</th>
                        <th>State</th>
                        <th>City</th>
                        <th *ngIf="isviewAll || isSuggestedOrFavorites || isPendingOffer">Asking Price</th>
                        <th *ngIf="isviewAll || isSuggestedOrFavorites || isPendingOffer">Cap Rate</th>
                        <th *ngIf="isviewAll || isSuggestedOrFavorites">Rent/NOI</th>
                        <th *ngIf="isviewAll || isSuggestedOrFavorites">Remaining Term</th>
                        <th *ngIf="isviewAll || isSuggestedOrFavorites">Credit Rating</th>
                        <th *ngIf="isviewAll || isSuggestedOrFavorites">Lease Structure</th>
                        <th *ngIf="isviewAll || isSuggestedOrFavorites">Property Type</th>
                        <th *ngIf="isviewAll || isUnderContractOrOthers  || isPendingOffer">Offer Price</th>
                        <th *ngIf="isviewAll || isUnderContractOrOthers || isPendingOffer">Earnest Money Deposit</th>
                        <th *ngIf="isviewAll || isUnderContractOrOthers || isPendingOffer">Due Diligence Period</th>
                        <th *ngIf="isviewAll || isUnderContractOrOthers || isPendingOffer">HC Period</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of portfolioList; let i = index">
                        <td>
                          <!--commented-->
                          <label class="custom-checkbox withoutlabel">
                            <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
                            <i></i>
                          </label>
                        </td>
                        <td *ngIf="isviewAll||viewActions" class="whitespacenowrap">
                          <div class="d-flex">
                            <div class="btn-group mr-5" dropdown 
                              *ngIf="item.GroupId === tables.suggested || item.GroupId === tables.wishlist" container="body">
                              <button id="button-basic" dropdownToggle tooltip="Actions" type="button"
                                class="view dropdown-toggle" aria-controls="dropdown-basic">
                                <i class="fa fa-cog" aria-hidden="true"></i>
                              </button>
                              <ul id="dropdown-basic" *dropdownMenu
                                class="dropdown-menu leftaligned-dropdown" role="menu"
                                aria-labelledby="button-basic">
                                <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);"
                                    *ngIf="item.GroupId != tables.suggested"
                                    (click)="onMove(item.Id,tables.suggested);">Move to Suggested</a></li>
                                <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);"
                                    *ngIf="item.GroupId != tables.wishlist"
                                    (click)="onMove(item.Id,tables.wishlist);">Move to Favorites</a></li>

                                <!--[UNCOMMENT THIS FOR ANALYSIS] <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" *ngIf="item.GroupId != tables.analysis" (click)="onMove(item.Id,tables.analysis);">Move to Analysis Portfolio</a></li>-->
                                <!--<li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" *ngIf="item.GroupId != tables.portfolio" (click)="onMove(item.Id,tables.portfolio);">Move to Pending Offers</a></li>-->
                                <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);"
                                    *ngIf="(item.GroupId == tables.portfolio) && item.OfferPlaced === 0"
                                    [routerLink]="['/viewproperty/'+item.PropertyGuid]"
                                    [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">Place
                                    Offer</a></li>
                                <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);"
                                    *ngIf="item.OfferPlaced !== 0" [routerLink]="['/offer-detail/'+item.OfferGuid]"
                                    [queryParams]="{prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">Offer
                                    Detail</a></li>
                              </ul>
                            </div>

                            <a class="remove" tooltip="Remove" href="javascript:void(0);"
                              *ngIf="item.GroupId === tables.suggested || item.GroupId === tables.wishlist"
                              (click)="openModal(template,'deletemodal',item.Id)"><i class="icofont icofont-close"
                                aria-hidden="true"></i></a>
                            <p *ngIf="item.GroupId === tables.portfolio">-</p>
                          </div>
                        </td>
                        <td>

                          <a *ngIf="item.OMFilePath !=='NOACCESS'" href={{item.OMFilePath}} download="Document.pdf"
                            target="_blank" [ngClass]="{'border-link':(item.OMFilePath!=null)}"><i
                              *ngIf="item.OMFilePath!=null" aria-hidden="true"
                              class="icofont icofont-download-alt downloadicon"></i>{{item.OMFilePath!=null?'OM':'-'}}</a>
                          <a *ngIf="item.OMFilePath ==='NOACCESS' && (!item.IsArchive || authService.Admin() || authService.SuperAdmin())" href="#"
                            routerLink="/viewproperty/{{item.PropertyGuid}}"
                            [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink,tab:'Memorandom'}"
                            [ngClass]="{'border-link':(item.OMFilePath!=null)}"><i *ngIf="item.OMFilePath!=null"
                              aria-hidden="true"
                              class="icofont icofont-download-alt downloadicon"></i>{{item.OMFilePath!=null?'OM':'-'}}</a>
                          <a *ngIf="item.OMFilePath ==='NOACCESS' && (item.IsArchive && !authService.Admin() && !authService.SuperAdmin())"
                            (click)="onArchiveClick()"><i *ngIf="item.OMFilePath!=null" aria-hidden="true"
                              class="icofont icofont-download-alt downloadicon"></i>{{item.OMFilePath!=null?'OM':'-'}}</a>
                        </td>
                        <td><a href={{item.LOIFilePath}} download="Document.pdf" target="_blank"
                            [ngClass]="{'border-link':(item.LOIFilePath!=null)}"><i *ngIf="item.LOIFilePath!=null"
                              aria-hidden="true"
                              class="icofont icofont-download-alt downloadicon"></i>{{item.LOIFilePath!=null?'LOI':'-'}}</a>
                        </td>
                        <td>
                          <div class="msg-wrap">
                            <sup class="message-count-unread msg" title="Unread"
                              *ngIf="item.UnReadMessageCount > 0 && !item.IsSendByMe"> {{item.UnReadMessageCount}}
                            </sup>
                            <sup class="message-count-byme msg" title="Delivered" *ngIf="item.IsSendByMe"> </sup>
                            <sup class="message-count-read msg" title="No new message"
                              *ngIf="item.UnReadMessageCount == 0 && !item.IsSendByMe && item.IsGroupCreated"> </sup>
                            <a class="blueone"
                              (click)="openMessageTab(templateMessageTab,'panlestyle messagepanel',item)"><i
                                class="icon-chat icon"></i></a>
                          </div>



                        </td>
                        <td *ngIf="isviewAll">
                          <p
                            [ngClass]="{'favoritelabel':(item.Title === 'Favorites'),'suggestedlabel':item.Title === 'Suggested','pendinglabel':item.Title === 'Pending Offer','offeracceptedlabel':item.Title === 'Offer Accepted','undercontractlabel':item.Title === 'Under Contract','hardcontractlabel':item.Title === 'Hard Contract','closeddealslabel':item.Title === 'Closed','declineddealslabel':item.Title==='Declined'}">
                            {{item.Title =='Declined/Cancelled' ? 'Declined/Canceled' : item.Title}}</p>
                        </td>
                        <td>
                          <a *ngIf="item.OfferGuid!=null && item.OfferExchangeId != 0 && item.OfferExchangeId != null"
                            href="#" routerLink="/offer-detail/{{item.OfferGuid}}"
                            [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
                          <a *ngIf="(item.OfferGuid==null || item.OfferExchangeId == 0 || item.OfferExchangeId == null) && (!item.IsArchive || authService.Admin()|| authService.SuperAdmin())"
                            href="#" routerLink="/viewproperty/{{item.PropertyGuid}}"
                            [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
                          <a *ngIf="(item.OfferGuid==null || item.OfferExchangeId == 0 || item.OfferExchangeId == null) && (item.IsArchive && !authService.Admin() && !authService.SuperAdmin())"
                            (click)="onArchiveClick()">{{item.PropertyName}}</a>

                        </td>
                        <td *ngIf="showStarRating"
                          (click)="openStarRatingModal(templateStarRating,'deletemodal starratingmodal',item.Id,item.RatingToShow,item.StarRating)">
                          <div class="starouter">
                            <span *ngFor="let star of item.RatingToShow;let i=index" triggers="mouseenter:mouseleave" tooltip="{{i+1}}"
                              style="cursor:pointer;">
                              <i class="fa" [ngClass]="{'fa-star':(star === 1),'fa-star-o':(star === 0) }"></i>
                            </span>
                          </div>
                        </td>
                        <td>
                          <p
                            [ngClass]="{'redtextlabel':(item.Status === 'Closed' || item.Status === 'Sold'),'greentextlabel':item.Status === 'Available','orangetextlabel':item.Status === 'Under Contract','not-available':item.Status === 'Not Available','Off-Market':item.Status === 'Off-Market'}">
                            {{ item.Status }}</p>
                        </td>
                        <td>
                          <p *ngIf="haveaccesstoviewlocation">{{item.State}}</p>
                          <p *ngIf="!haveaccesstoviewlocation">{{item.ConfidentialLocation ? 'Confidential':item.State}}
                          </p>
                        </td>
                        <td>
                          <p class="min-width-75" *ngIf="haveaccesstoviewlocation">{{item.City}}</p>
                          <p class="min-width-75" *ngIf="!haveaccesstoviewlocation">{{item.ConfidentialLocation ?
                            'Confidential':item.City}}</p>
                        </td>
                        <td *ngIf="(isviewAll || isSuggestedOrFavorites || isPendingOffer) && item.Unpriced">
                          <p class="whitespacenowrap">Unpriced</p>
                        </td>
                        <td *ngIf="(isviewAll || isSuggestedOrFavorites || isPendingOffer) && !item.Unpriced">
                          <p class="whitespacenowrap">{{(item.Price) ? '$ '+(item.Price |number:0) : '-'}}</p>
                        </td>
                        <td *ngIf="(isviewAll || isSuggestedOrFavorites || isPendingOffer)">
                          <p *ngIf="item.CharacteristicsId == 1" class="whitespacenowrap">ZCF</p>

                          <p *ngIf="item.CharacteristicsId != 1" class="whitespacenowrap">{{(item.CapRate) ?
                            (item.CapRate)+'%' : '-'}}</p>
                        </td>
                        <td *ngIf="isviewAll || isSuggestedOrFavorites">
                          <p class="whitespacenowrap">{{(item.NOI) ? '$ '+(item.NOI |number:0) : '-'}}</p>
                        </td>
                        <td *ngIf="isviewAll || isSuggestedOrFavorites">
                          <p>{{item.Term | yearsMonthConverter:true}}</p>
                        </td>
                        <td *ngIf="isviewAll || isSuggestedOrFavorites">
                          <p>{{item.Rating!=null?item.Rating:'-'}}</p>
                        </td>
                        <td *ngIf="isviewAll || isSuggestedOrFavorites">
                          <p>{{item.LeaseStructure ? item.LeaseStructure:'-' }}</p>
                        </td>
                        <td *ngIf="isviewAll || isSuggestedOrFavorites"><span tooltip="{{item.Type}}">{{item.Type ?
                            commonService.GetPropertyTypeWithCount(item.Type) : '-'}}</span></td>

                        <td *ngIf="isviewAll || isUnderContractOrOthers || isPendingOffer">
                          <p class="whitespacenowrap">{{(item.OfferPrice) ? '$ '+(item.OfferPrice |number:0) : '-'}}</p>
                        </td>
                        <td *ngIf="isviewAll || isUnderContractOrOthers || isPendingOffer">
                          <p class="whitespacenowrap">{{(item.EarnestMoneyDeposit) ? '$ '+(item.EarnestMoneyDeposit
                            |number:0) : '-'}}</p>
                        </td>
                        <td *ngIf="isviewAll || isUnderContractOrOthers || isPendingOffer" class="whitespacenowrap">
                          <p>{{item.DDCloseDate ? (_ValidationService.convertUTCDateToLocalDate(item.DDCloseDate)|
                            date:'MM/dd/yyyy') : '-'}}</p>
                        </td>
                        <td *ngIf="isviewAll || isUnderContractOrOthers || isPendingOffer" class="whitespacenowrap">
                          <p>{{item.CPCloseDate ? (_ValidationService.convertUTCDateToLocalDate(item.CPCloseDate)|
                            date:'MM/dd/yyyy') : '-'}}</p>
                        </td>

                      </tr>
                    </tbody>
                    <tfoot>
                      <tr *ngIf="portfolioList?.length == 0 ">
                        <td colspan="20" class="odd no-data-available">
                          <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Data Available</p>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

              </div>
              <!--List View End here-->
              <!--Grid View Start here-->
              <!--<div cdkDropListGroup>
                <div class="example-container">
                  <h2>To do</h2>

                  <div cdkDropList
                       [cdkDropListData]="suggested"
                       class="example-list"
                       (cdkDropListDropped)="drop($event)">
                    @for (item of suggested; track item) {
                    <div class="example-box" cdkDrag>{{item}}</div>
                    }
                  </div>
                </div>

                <div class="example-container">
                  <h2>Done</h2>

                  <div cdkDropList
                       [cdkDropListData]="done"
                       class="example-list"
                       (cdkDropListDropped)="drop($event)">
                    @for (item of done; track item) {
                    <div class="example-box" cdkDrag>{{item}}</div>
                    }
                  </div>
                </div>
              </div>-->

              <div class="dragndropcards row" *ngIf="view === Views.Grid">

                <div class="dragndropcardsmin-width">
                  <div class=" ">
                    <div cdkDropListGroup>
                      <div class="col-sm-4 col-xs-4 col-md-4 col-lg-4">
                        <div class="card  mb-3">
                          <div class="card-header card-inverse">
                            Suggested
                            <span>${{getTotalPrice(suggested,1)|number}}</span>
                            ({{suggested?.length}})
                          </div>
                          <div cdkDropList [cdkDropListData]="suggested" class="example-list"
                            (cdkDropListDropped)="drop($event, tables.suggested)">
                            <div *ngIf="suggested?.length==0">
                              <div class="dragndroptext">
                                Drag and Drop Properties here
                              </div>
                            </div>
                            @for (item of suggested; track item) {
                            <div class="example-box" cdkDrag>
                              <label class="custom-checkbox withoutlabel">
                                <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
                                <i></i>
                              </label>

                              <a class="property-name" href="#" routerLink="/viewproperty/{{item.PropertyGuid}}"
                                [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
                              <h6 class="itemprice">
                                $ {{item.Price | number}}<span class="placeoffer"
                                  *ngIf="item.GroupId == tables.portfolio"><a>Place Offer</a></span>

                              </h6>
                              <div class="clearfix"></div>
                              <h5 class="state-city" *ngIf="haveaccesstoviewlocation">{{item.City}} , {{item.State}}
                              </h5>
                              <h5 class="state-city" *ngIf="!haveaccesstoviewlocation">
                                {{item.ConfidentialLocation?'Confidential':item.City+' , '}}
                                {{item.ConfidentialLocation?'':item.State}}</h5>
                              <div class="btn-group rightdropdown option" dropdown>
                                <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle more-options"
                                  tooltip="More Options" container="body" placement="top" trigger="hover"
                                  aria-controls="dropdown-basic">
                                  <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                                </button>
                                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                  role="menu" aria-labelledby="button-basic">
                                  <li role="menuitem"><a class="dropdown-item"
                                      (click)="openModal(template,'deletemodal',item.Id)"
                                      href="javascript:void(0);">Remove</a></li>
                                  <li role="menuitem" *ngIf="item.OfferPlaced !== 0"><a
                                      [routerLink]="['/offer-detail/'+item.OfferGuid]"
                                      [queryParams]="{prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">Offer
                                      Detail</a></li>


                                </ul>
                              </div>
                            </div>
                            }
                          </div>
                        </div>

                      </div>
                      <div class="col-sm-4 col-xs-4 col-md-4 col-lg-4">
                        <div class="card  mb-3">
                          <div class="card-header card-inverse">
                            Favorites
                            <span>${{getTotalPrice(wishlist,1)|number}}</span>
                            ({{wishlist?.length}})
                          </div>
                          <div cdkDropList [cdkDropListData]="wishlist" class="example-list"
                            (cdkDropListDropped)="drop($event, tables.wishlist)">
                            <div *ngIf="wishlist?.length==0">
                              <div class="dragndroptext">
                                Drag and Drop Properties here
                              </div>
                            </div>
                            @for (item of wishlist; track item) {
                            <div class="example-box" cdkDrag>
                              <label class="custom-checkbox withoutlabel">
                                <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
                                <i></i>
                              </label>

                              <a class="property-name" href="#" routerLink="/viewproperty/{{item.PropertyGuid}}"
                                [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
                              <h6 class="itemprice">
                                $ {{item.Price | number}}<span class="placeoffer"
                                  *ngIf="item.GroupId == tables.portfolio"><a>Place Offer</a></span>

                              </h6>
                              <div class="clearfix"></div>
                              <h5 class="state-city" *ngIf="haveaccesstoviewlocation">{{item.City}} , {{item.State}}
                              </h5>
                              <h5 class="state-city" *ngIf="!haveaccesstoviewlocation">
                                {{item.ConfidentialLocation?'Confidential':item.City+' , '}}
                                {{item.ConfidentialLocation?'':item.State}}</h5>
                              <div class="btn-group rightdropdown option" dropdown>
                                <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle more-options"
                                  tooltip="More Options" container="body" placement="top" trigger="hover"
                                  aria-controls="dropdown-basic">
                                  <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                                </button>
                                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                  role="menu" aria-labelledby="button-basic">
                                  <li role="menuitem"><a class="dropdown-item"
                                      (click)="openModal(template,'deletemodal',item.Id)"
                                      href="javascript:void(0);">Remove</a></li>
                                  <li role="menuitem" *ngIf="item.OfferPlaced !== 0"><a
                                      [routerLink]="['/offer-detail/'+item.OfferGuid]"
                                      [queryParams]="{prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">Offer
                                      Detail</a></li>
                                  <!--commented-->
                                </ul>
                              </div>
                            </div>
                            }
                          </div>
                        </div>
                      </div>

                      <!--<div class="card card-outline-primary mb-3" droppable [dragOverClass]="'drag-target-border-green'" [dropScope]="'Exchange'"
     [dragHintClass]="'drag-hint'" (onDrop)="onDrop($event,tables.wishlist)">
  <div class="card-header card-inverse card-primary">
    Favorites-->
                      <!--commented-->
                      <!--: <span>${{getTotalPrice(wishlist,1)|number}}</span>-->
                      <!--<a href="#" class="info"><span class="icon-info"></span></a>-->
                      <!--({{wishlist?.length}})
  </div>
  <div class="card-block scroll-list">
    <ul class="list-group">
      <li class="list-group-item" [ngStyle]="{'background-color':item.OfferPlaced ? 'rgb(230, 240, 247)' :'#fff'}" [ngClass]="{'blueborder':item.IsChecked}" [draggable] (onDragStart)="onDrag($event,tables.wishlist);" *ngFor="let item of wishlist" [dragClass]="'active'"
          [dragTransitClass]="'active'" [dragData]="item" [dragScope]="item.Type" [dragEnabled]="dragEnabled">-->
                      <!--commented-->
                      <!--<label class="custom-checkbox withoutlabel">
    <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
    <i></i>
  </label>

  <a class="property-name" href="#" routerLink="/viewproperty/{{item.PropertyGuid}}" [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
  <h6 class="itemprice">
    $ {{item.Price | number}}<span class="placeoffer" *ngIf="item.GroupId == tables.portfolio"><a>Place Offer</a></span>

  </h6>
  <div class="clearfix"></div>
  <h5 class="state-city" *ngIf="haveaccesstoviewlocation">{{item.City}} , {{item.State}}</h5>
  <h5 class="state-city" *ngIf="!haveaccesstoviewlocation">{{item.ConfidentialLocation?'Confidential':item.City+' , '}} {{item.ConfidentialLocation?'':item.State}}</h5>
  <div class="btn-group rightdropdown option" dropdown>
    <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle" tooltip="More Options" container="body" placement="top" trigger="hover"
            aria-controls="dropdown-basic">
      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
    </button>
    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
        role="menu" aria-labelledby="button-basic">
      <li role="menuitem"><a class="dropdown-item" (click)="openModal(template,'deletemodal',item.Id)" href="javascript:void(0);">Remove</a></li>
      <li role="menuitem" *ngIf="item.OfferPlaced !== 0"><a [routerLink]="['/offer-detail/'+item.OfferGuid]" [queryParams]="{prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">Offer Detail</a></li>-->
                      <!--commented-->
                      <!--</ul>
          </div>

        </li>
        <li *ngIf="wishlist?.length==0">
          <div class="dragndroptext">
            Drag and Drop Properties here
          </div>
        </li>
      </ul>
    </div>
  </div>-->
                    </div>
                    <div class="col-sm-4 col-xs-4 col-md-4 col-lg-4">
                      <div class="card card-outline-primary mb-3">
                        <div class="card-header card-inverse card-primary">
                          Pending Offer
                          <!--commented-->
                          : <span>${{getTotalPrice(portfolio,1)|number}}</span>
                          <!--<a href="#" class="info"><span class="icon-info"></span></a>-->
                          ({{portfolio?.length}})
                          <!--[UNCOMMENT THIS FOR ANALYSIS]<a style="float:right" (click)="onGroupCreate(AddGroup,'panlestyle',tables.portfolio);">Add Group</a>-->
                        </div>

                        <div class="card-block scroll-list">
                          <ul class="list-group">
                            <li class="list-group-item list-group-item-action" *ngFor="let item of portfolio">
                              <!--commented-->
                              <label class="custom-checkbox withoutlabel">
                                <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
                                <i></i>
                              </label>

                              <a href="#" class="property-name"
                                routerLink="/viewproperty/{{item.PropertyGuid}}">{{item.PropertyName}}</a>
                              <h6 class="itemprice" *ngIf="item.OfferPlaced == 0">
                                $ {{item.Price | number}}
                              </h6>
                              <h6 class="itemprice" *ngIf="item.OfferPlaced > 0">
                                $ {{item.OfferPrice | number}}
                              </h6>
                              <div class="clearfix"></div>
                              <h5 class="state-city" *ngIf="haveaccesstoviewlocation">{{item.City}} , {{item.State}}
                              </h5>
                              <h5 class="state-city" *ngIf="!haveaccesstoviewlocation">
                                {{item.ConfidentialLocation?'Confidential':item.City+' , '}}
                                {{item.ConfidentialLocation?'':item.State}}</h5>
                              <div class="btn-group rightdropdown option" dropdown>
                                <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle more-options"
                                  tooltip="More Options" container="body" placement="top" trigger="hover"
                                  aria-controls="dropdown-basic">
                                  <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                                </button>
                                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                                  role="menu" aria-labelledby="button-basic">
                                  <li role="menuitem"><a class="dropdown-item"
                                      (click)="openModal(template,'deletemodal',item.Id)"
                                      href="javascript:void(0);">Remove</a></li>
                                  <li role="menuitem"
                                    *ngIf="(item.GroupId == tables.portfolio) && item.OfferPlaced === 0"><a
                                      [routerLink]="['/viewproperty/'+item.PropertyGuid]"
                                      [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">Place
                                      Offer</a></li>
                                  <li role="menuitem" *ngIf="item.OfferPlaced !== 0"><a
                                      [routerLink]="['/offer-detail/'+item.OfferGuid]"
                                      [queryParams]="{prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">Offer
                                      Detail</a></li>
                                  <!--commented-->
                                </ul>
                              </div>
                            </li>
                            <li *ngIf="portfolio?.length==0">
                              <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                              </div>
                            </li>
                          </ul>
                        </div>


                      </div>
                    </div>
                    <div class="clearfix"></div>

                    <div class="col-sm-4 col-xs-4 col-md-4 col-lg-4 margin-top-20">
                      <div class="card  mb-3">
                        <div class="card-header card-inverse">
                          Offer Accepted
                          : <span>${{getTotalPrice(OfferAccepted,2)|number}}</span>
                          ({{OfferAccepted?.length}})
                        </div>
                        <div class="card-block scroll-list">
                          <ul class="list-group">
                            <li class="list-group-item list-group-item-action" *ngFor="let item of OfferAccepted">
                              <label class="custom-checkbox withoutlabel">
                                <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
                                <i></i>
                              </label>
                              <a href="#" class="property-name" routerLink="/viewproperty/{{item.PropertyGuid}}"
                                [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
                              <h6 class="itemprice">
                                $ {{item.Price | number}}
                              </h6>
                              <div class="clearfix"></div>
                              <h5 class="state-city" *ngIf="haveaccesstoviewlocation">{{item.City}} , {{item.State}}
                              </h5>
                              <h5 class="state-city" *ngIf="!haveaccesstoviewlocation">
                                {{item.ConfidentialLocation?'Confidential':item.City+' , '}}
                                {{item.ConfidentialLocation?'':item.State}}</h5>
                            </li>
                            <li *ngIf="OfferAccepted?.length===0">
                              <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 col-xs-4 col-md-4 col-lg-4 margin-top-20">
                      <div class="card  mb-3">
                        <div class="card-header card-inverse">
                          Under Contract
                          : <span>${{getTotalPrice(UnderContract,2)|number}}</span>
                          ({{UnderContract?.length}})

                        </div>
                        <div class="card-block scroll-list">
                          <ul class="list-group">
                            <li class="list-group-item list-group-item-action" *ngFor="let item of UnderContract">
                              <label class="custom-checkbox withoutlabel">
                                <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
                                <i></i>
                              </label>
                              <a href="#" class="property-name" routerLink="/viewproperty/{{item.PropertyGuid}}"
                                [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
                              <h6 class="itemprice">
                                $ {{item.Price | number}}
                              </h6>
                              <div class="clearfix"></div>
                              <h5 class="state-city" *ngIf="haveaccesstoviewlocation">{{item.City}} , {{item.State}}
                              </h5>
                              <h5 class="state-city" *ngIf="!haveaccesstoviewlocation">
                                {{item.ConfidentialLocation?'Confidential':item.City+' , '}}
                                {{item.ConfidentialLocation?'':item.State}}</h5>
                            </li>
                            <li *ngIf="UnderContract?.length===0">
                              <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 col-xs-4 col-md-4 col-lg-4 margin-top-20">
                      <div class="card  mb-3">
                        <div class="card-header card-inverse">
                          Hard Contract
                          : <span>${{getTotalPrice(HardContract,2)|number}}</span>
                          ({{HardContract?.length}})

                        </div>
                        <div class="card-block scroll-list">
                          <ul class="list-group">
                            <li class="list-group-item list-group-item-action" *ngFor="let item of HardContract">
                              <label class="custom-checkbox withoutlabel">
                                <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
                                <i></i>
                              </label>
                              <a href="#" class="property-name" routerLink="/viewproperty/{{item.PropertyGuid}}"
                                [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
                              <h6 class="itemprice">
                                $ {{item.Price | number}}
                              </h6>
                              <div class="clearfix"></div>
                              <h5 class="state-city" *ngIf="haveaccesstoviewlocation">{{item.City}} , {{item.State}}
                              </h5>
                              <h5 class="state-city" *ngIf="!haveaccesstoviewlocation">
                                {{item.ConfidentialLocation?'Confidential':item.City+' , '}}
                                {{item.ConfidentialLocation?'':item.State}}</h5>
                            </li>
                            <li *ngIf="HardContract?.length===0">
                              <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!--<div class="col-sm-4 col-xs-4 col-md-4 col-lg-4 margin-top-20">
          <div class="card  mb-3">
              <div class="card-header card-inverse">
                  Closed Deals
                  : <span>${{getTotalPrice(Closed,2)|number}}</span>
                  ({{Closed?.length}})

              </div>
              <div class="card-block scroll-list">
                  <ul class="list-group">
                    <li class="list-group-item list-group-item-action" *ngFor="let item of Closed">
                      <label class="custom-checkbox withoutlabel">
                        <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onChecked(item);">
                        <i></i>
                      </label>
                      <a href="#" class="property-name" routerLink="/viewproperty/{{item.PropertyGuid}}" [queryParams]="{ prevroute:BreadCrumb.PrevPageName , link:BreadCrumb.PrevPageLink}">{{item.PropertyName}}</a>
                      <h6 class="itemprice">
                        $ {{item.Price | number}}
                      </h6>
                      <div class="clearfix"></div>
                      <h5 class="state-city" *ngIf="haveaccesstoviewlocation">{{item.City}} , {{item.State}}</h5>
                      <h5 class="state-city" *ngIf="!haveaccesstoviewlocation">{{item.ConfidentialLocation?'Confidential':item.City+' , '}} {{item.ConfidentialLocation?'':item.State}}</h5>
                    </li>
                      <li *ngIf="Closed?.length===0">
                          <div class="nodata">
                              <i class="fa fa-exclamation-triangle icon"></i>
                              <p>No Data Available</p>
                          </div>
                      </li>
                  </ul>
              </div>
          </div>
      </div>-->


                  </div>
                </div>

              </div>

              <!--Grid View end here-->


            </tab>
            <tab heading="Saved Analysis">
              <app-portfolio-analysis [exchangeId]="selectedExchange"></app-portfolio-analysis>
            </tab>
          </tabset>
        </div>

        <!--Delete Confirmation pop up Start here-->
        <ng-template #template>

          <div class="modal-header">
            <h4 class="modal-title pull-left">Delete Exchange {{popupheading}}</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="clear();modalRef.hide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body padding30">

            <div class="form-group">
              <h6 class="displayvalue">Are you sure you'd like to remove this property ?</h6>
            </div>
            <div class="text-right">
              <button class="btn btn-lg btn-default" (click)="clear();modalRef.hide()">Cancel</button>
              <button class="btn btn-lg btn-danger"
                (click)="removeExchangeProperty(propertyToDelete);modalRef.hide();">Delete</button>
            </div>
          </div>

        </ng-template>
        <!--Delete Confirmation pop up End here-->
        <!--Add or Edit Portfolio Name Master Pop up Start here-->
        <ng-template #AddGroup class="pull-left">
          <div class="modal-header">
            <h4 class="modal-title pull-left">{{popupheader}}</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="form-label">Group Name</label>
              <input class="form-control" #GroupName="ngModel" [(ngModel)]="groupNameInput" maxlength="100" required
                type="text">
              <p class="redtext"
                *ngIf="(_ValidationService.IsinValid(groupNameInput) && isSubmitGroup) ||(GroupName.invalid && GroupName.touched)">
                Group Name is required </p>
            </div>
            <div class="">
              <button class="btn btn-secondary" id="closeModal" (click)="modalRef.hide();">Cancel</button>
              <button class="btn btn-success" (click)="onAddGroup();">Add Group</button>
            </div>
          </div>

        </ng-template>
        <!--Add or Edit Portfolio Name Master Pop up end here-->
        <!--Delete Confirmation pop up for Portfolio Name Start here-->
        <ng-template #PName>

          <div class="modal-header">
            <h4 class="modal-title pull-left">Delete Portfolio Name </h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="clear();modalRef.hide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body padding30">

            <div class="form-group">
              <h6 class="displayvalue">Are you sure to delete ?</h6>
            </div>
            <div class="text-right">
              <button class="btn btn-lg btn-default" (click)="clear();modalRef.hide()">Cancel</button>
              <button class="btn btn-lg btn-danger" (click)="DeletePortfolioGroup();modalRef.hide();">Delete</button>
            </div>
          </div>

        </ng-template>
        <!--Delete Confirmation pop up for Portfolio Name End here-->
        <!--Property Suggest pop up Start here-->
        <ng-template #PropertySuggest>
          <app-property-suggest [selectedExchange]="exchangeSelected" [suggested]="suggested"
            (close)="onClose($event)"></app-property-suggest>
        </ng-template>
        <!--Property Suggest pop up Ends here-->
        <!--Star Rating pop up Starts here-->
        <ng-template #templateStarRating>

          <div class="modal-body padding30">
            <h6 class="displayvalue margin-bottom-5">Update Rating</h6>
            <div class="stars">
              <span *ngFor="let star of rating;let i=index" (click)="setStar(i,idToRate)" triggers="mouseenter:mouseleave" tooltip="{{i+1}}"
                style="cursor:pointer;">
                <i class="fa" [ngClass]="{'fa-star':(star === 1),'fa-star-o':(star === 0) }"></i>
              </span>
            </div>
            <div class="text-right">
              <button class="btn btn-lg btn-default" (click)="onClose(true)">Cancel</button>
              <button *ngIf="starRating > 0" class="btn btn-lg btn-danger"
                (click)="setStar(-1,idToRate)">Remove</button>
            </div>
          </div>
        </ng-template>
        <!--Star Rating pop up Ends here-->

      </div>
    </div>
  </div>
</div>

<div *ngIf="comparisonService.isComparePage">
  <app-property-comparison [isPropertyAnalysis]="isPropertyAnalysis"></app-property-comparison>
</div>

<ng-template #templateMessageTab>
  <app-messages-view [propertyGuid]="selectedPropertyGuid" [SelexchangeId]="exchangeSelected"
    [fromExchangePropertyList]="true" [modalRef]="modalRef"></app-messages-view>
</ng-template>



<ng-template #popTemplate>Here we go: <div [innerHtml]="html"></div></ng-template>
